import { render, staticRenderFns } from "./LearnAboutBins.vue?vue&type=template&id=3130e02a&scoped=true"
import script from "./LearnAboutBins.vue?vue&type=script&lang=js"
export * from "./LearnAboutBins.vue?vue&type=script&lang=js"
import style0 from "./LearnAboutBins.vue?vue&type=style&index=0&id=3130e02a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3130e02a",
  null
  
)

export default component.exports